export default class CaseTransformer {
  static toSnake(string) {
    return string
      .split('')
      .map((letter, index) => {
        if (/[A-Z]/.test(letter)) {
          return `_${letter.toLowerCase()}`
        }
        return letter
      })
      .join('');
  }

  static toCamel(string) {
    return string.replace(/_([a-z0-9])/g, (match, letter) => letter.toUpperCase());
  }

  static keysToCamel(object) {
    const entries = Object.entries(object);
    entries.forEach((entry, idx) => {
      entries[idx][0] = CaseTransformer.toCamel(entries[idx][0]);
    });
    return Object.fromEntries(entries);
  }

  static keysToSnake(object) {
    const entries = Object.entries(object);
    entries.forEach((entry, idx) => {
      entries[idx][0] = CaseTransformer.toSnake(entries[idx][0])
    });
    return Object.fromEntries(entries);
  }
}
